import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Older Android APKs launch this exact support URL. Normalize it before the
// router mounts; ordinary support links and notification taps still open chat.
const launchUrl = new URL(window.location.href);
if (launchUrl.pathname === "/admin/support-app"
  && launchUrl.searchParams.get("app_v") === "20260903-admin-cache-fix") {
  launchUrl.pathname = "/admin/dashboard";
  launchUrl.searchParams.delete("app_v");
  window.history.replaceState(window.history.state, "", launchUrl);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker and refresh once when a new build takes control.
if ("serviceWorker" in navigator) {
  let refreshingForServiceWorker = false;
  const reloadForServiceWorker = (version = "controllerchange") => {
    if (refreshingForServiceWorker) return;
    const reloadKey = `fea-sw-${version}`;
    if (sessionStorage.getItem(reloadKey)) return;
    refreshingForServiceWorker = true;
    sessionStorage.setItem(reloadKey, "1");
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    reloadForServiceWorker();
  });

  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type !== "FEA_SW_UPDATED") return;
    reloadForServiceWorker(event.data.version);
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js?v=20260923-admin-dashboard-launch")
      .then((registration) => {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        return registration.update();
      })
      .catch(() => {
        // Site still works without the service worker.
      });
  });
}
